import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

const addCourt = async (data) => {
  const url = `v1/orgs/${selectedOrgId()}/courts`

  const response = await axiosInstance.post(url, JSON.stringify(data))

  return response?.data
}

export default addCourt
